import React, { useEffect, useMemo, useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Card, CardBody, Col, Row } from "reactstrap";
import AdvanceSearch from "../../CommonComponents/AdvanceSearch";
import { useSelector } from "react-redux";
import {
  Accordion,
  AccordionDetails
} from "@mui/material";
import { loadingPanel } from "../../CommonComponents/CommonFunction";
import TelerikDataTable from "../../CommonComponents/TelerikDataTable";
import visileColumnsJobOrder from "./visibleColumnsJobOrder";

const jobOrderSelect = "jobOrderSelect";

const JobOrderSelectModal = ({ jobOrderModal, setJobOrderModal,setFieldValue }) => {
  const { sort } = useSelector((state) => state?.CommonReducer) || {};
  const [isActive, setIsActive] = useState("A%");
  const { employeeAuditHistory, isValidEmply, loadingEmployeeSearch } =
  useSelector((state) => state.employeeReducer);
  const {
    columns,
    loadingSearch,
    ColumnsSorted,
    searchParameter,
    searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  // console.log("Dasdadaasdasdsad", results);
  const [searchParams, setSearchParams] = useState([]);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortedColumns, setSortedColumns] = useState([]);
  const [openHistory, setOpenHistory] = React.useState(false);

  const [sortData, setSortData] = useState(
    sort && sort[jobOrderSelect] ? sort[jobOrderSelect] : []
  );
  const [pageSize, setPageSize] = useState(100);
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);
 
  useEffect(() => {
    if (ColumnsSorted[jobOrderSelect] !== undefined) {
      setSortedColumns(ColumnsSorted[jobOrderSelect]);
    } else {
       if (columns && visileColumnsJobOrder.length > 0 && columns.length > 0) {
        const clms = visileColumnsJobOrder.map((d) => d.field.toLowerCase());
        const data = columns
          .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
          .map((p) => {
            return {
              field: p.column_name,
              show: false,
              locked: false,
              width: 200,
              title: p.column_title,
              filter: "text",
            };
          });
        setSortedColumns(visileColumnsJobOrder.concat(data));
      } else {
        return;
      }
    }
  }, [columns]); 

  const actions = useMemo(() => {
    return [
      {
        title: "Select JobOrder",
        action: (props) => {
          console.log("Dadasdsadad", props);
          // setFieldValue("JOB_Order_Number",props?.dataItem['Job_Number'])
          // setFieldValue("AS400_Account_No",props?.dataItem['AS400_Account_No'])
          // setFieldValue("D365_Account_No",props?.dataItem['D365_Account_No'])
          // setFieldValue("Description",props?.dataItem['Description'])
          // setFieldValue("Fund_Dimension",props?.dataItem['Fund_Dimension'])
          // setFieldValue("Main_Account",props?.dataItem['Main_Account'])
          // setFieldValue("Year_Dimension",props?.dataItem['Year_Dimension']) 
          setFieldValue("JOB_Order_Number",props?.dataItem['Job_Number'])
          setFieldValue("Main_Account",props?.dataItem['D365_Account_No'])
          setFieldValue("Account_Description",props?.dataItem['Description'])
          setFieldValue("Description",props?.dataItem['Main_Account_Description'])

          setFieldValue("AS400_Account_No",props?.dataItem['AS400_Account_No'])
          // setFieldValue("D365_Account_No",props?.dataItem['D365_Account_No'])
          setFieldValue("Fund_Dimension",props?.dataItem['Fund_Dimension'])
          setFieldValue("Year_Dimension",props?.dataItem['Year_Dimension']) 
          setJobOrderModal(false)
        },
        icon: { iconName: 'k-icon  k-i-plus-outline' },
        className: "font-primary",
        style: { cursor: "pointer" },
        showAsButton : false
      }, 
    
    ];
  });
   
  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
    //setPageSize(10);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
    //setPageSize(10);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };

  return (
    <Dialog
      open={jobOrderModal}
      onClose={() => setJobOrderModal(!jobOrderModal)}
      scroll="body"
      maxWidth={"lg"}
      // PaperProps={{
      //   sx: {
      //     maxWidth: 1000,
      //   },
      // }}
      fullWidth={true}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle id="scroll-dialog-title">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0",
          }}
        >
          <h5 className="mt-2"></h5>
          <div>
            <IconButton></IconButton>

            <IconButton></IconButton>
            <IconButton onClick={() => setJobOrderModal(!jobOrderModal)}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>

      <DialogContent>
      <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody>
                  <AdvanceSearch
                    id={jobOrderSelect}
                    gridId={jobOrderSelect}
                    location="global"
                    columnList={"*"}
                    columnRefernces={[]}
                    tableName={"vw_joborder_detailed_lookup_blanket"}
                    // tableName={"vw_joborder_detailed_lookup"}
                    // tableName={"vw_joborder_gg1blanket_lookup"}
                    searchParams={searchParams}
                    additionalWhere={additionalWhere}
                    expanded={false}
                    sortData={sortData}
                    pageNumber={page}
                    pageSize={pageSize}
                    chooseFilterMethod={chooseFilterMethod}
                    isActive={isActive}
                  />
                  <Accordion
                    style={{ margin: "0px" }}
                    expanded={expandedSearchResult}
                  >
                    {/* <AccordionSummary
                      expandIcon={<ExpandMore />}
                      className="bg-light"
                      onClick={() =>
                        setexpandedSearchResult(!expandedSearchResult)
                      }
                    >
                      <Typography variant="h6">Search Results</Typography>
                    </AccordionSummary> */}
                    <AccordionDetails style={{ padding: "0px" }}>
                      {loadingEmployeeSearch && loadingPanel()}
                      <div>
                    
                          <TelerikDataTable
                          isDashboard={true}
                            id={jobOrderSelect}
                            pageSize={pageSize}
                            totalCount={rowCount}
                            skip={(page - 1) * pageSize}
                            take={pageSize}
                            data={results || []}
                            sortData={sortData}
                            onFilterChange={handleFilterChange}
                            onSortChange={handleSortChange}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            selectedColumns={sortedColumns}
                            setSortedColumns={setSortedColumns}
                            loading={loadingSearch}
                            actions={actions}
                            setChooseFilterMethod={setChooseFilterMethod}
                            chooseFilterMethod={chooseFilterMethod} 
                           
                          ></TelerikDataTable>
                        
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </CardBody>
              </Card>
            </Col>
          </Row>
      </DialogContent>
    </Dialog>
  );
};

export default JobOrderSelectModal;
